import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        user: false,
        permissions: {},
        settings: false,
    },
    mutations: {
        setSettings(state, data) {
            state.settings = data;
        },
        login(state, response) {
            state.user = response.user;
            localStorage.clear();
            state.permissions = response.user.role.permissions;
            localStorage.setItem('token', response.token);
            localStorage.setItem('user_prefrence', JSON.stringify(response.user));
            window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.token;
        },
        async logout(state) {
            await axios.post('api/auth/logout').then(function (response) {
                state.user = false;
                localStorage.clear();
                var res = response.data;
                if (res.saml == 1) {
                    window.location.href = res.logout_url;
                }
            });
            delete window.axios.defaults.headers.common.Authorization;
            localStorage.removeItem('token');
            localStorage.removeItem('user_prefrence');
            localStorage.removeItem('user_image');
        },
        setUser(state) {
            if (localStorage.getItem('token')) {
                axios.get('api/auth/user').then(function (response) {
                    state.user = response.data;
                    localStorage.setItem('user_prefrence', JSON.stringify(response.data));
                    state.permissions = response.data.role.permissions;
                    localStorage.setItem('user_image', response.data.avatar_path);
                });
            }
        },
        updateUser(state, response) {
            state.user = response;
            state.permissions = response.role.permissions;
        },
    }
});

export default store;

